export default __webpack_public_path__ + "static/media/ic_domain_48px.948de700.svg";